<template>
  <div>
    <v-select item-text="label" item-value="value" :items="[
      { value: 'OpenUI', label: '打开UI' },
      { value: 'PlayVideo', label: '播放视频' },
      { value: 'PlayAudio', label: '播放音频' },
      { value: 'MoveCamera', label: '移动摄像机' },
      { value: 'PlayerAction', label: '玩家操作' },
      { value: 'talk', label: '文本对话框' },
      { value: 'OpenImage', label: '打开图片' },
      { value: 'Exam', label: '考核' },
      { value: 'Effects', label: '特效' },
    ]" v-model="form.templateId" label="动作模板 *" :rules="[v => !!v || '动作模板不能为空']"></v-select>

    <v-select item-text="label" item-value="value" v-if="form.templateId === 'PlayAudio'" :items="[
      { value: 'backgroundMusic', label: '背景音乐' },
      { value: 'tipsAudio', label: '提示语音' },
      { value: 'actionMusic', label: '动作音效' },
    ]" v-model="form.audioType" label="音频类型 *" :rules="[v => !!v || '音频类型不能为空']"></v-select>

    <v-text-field v-if="form.templateId === 'PlayAudio'" label="音频名称 *" v-model="form.audioName"
      :rules="[v => !!v || '音频名称不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'PlayAudio'" label="播放时长 *" v-model="form.playTime"
      :rules="[v => !!v || '播放时长不能为空']"></v-text-field>


    <v-text-field v-if="form.templateId === 'Exam'" label="题目 *" v-model="form.question"
      :rules="[v => !!v || '题目不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'Exam'" label="答案 *" v-model="form.answer"
      :rules="[v => !!v || '答案不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'Exam'" label="分数 *" v-model="form.score"
      :rules="[v => !!v || '分数不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'OpenImage'" label="图片名称 *" v-model="form.spriteName"
      :rules="[v => !!v || '图片名称不能为空']"></v-text-field>

    <v-row v-if="form.templateId === 'OpenImage'">
      <v-col col="4">
        <span>坐标 *</span>
      </v-col>
      <v-col col="4">
        <v-text-field label="x *" v-model="form.spritePositionx" :rules="[v => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="4">
        <v-text-field label="y *" v-model="form.spritePositiony" :rules="[v => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="form.templateId === 'OpenImage'">
      <v-col col="4">
        <span>宽、高 *</span>
      </v-col>
      <v-col col="4">
        <v-text-field label="宽 *" v-model="form.spriteSizeWidth" :rules="[v => !!v || '宽 不能为空']"></v-text-field>
      </v-col>
      <v-col col="4">
        <v-text-field label="宽 *" v-model="form.spriteSizeHeight" :rules="[v => !!v || '高 不能为空']"></v-text-field>
      </v-col>
    </v-row>


    <v-text-field v-if="form.templateId === 'OpenUI'" label="界面名称 *" v-model="form.uiPanelName"
      :rules="[v => !!v || '界面名称不能为空']"></v-text-field>


    <v-text-field v-if="form.templateId === 'talk'" label="内容 *" v-model="form.content"
      :rules="[v => !!v || '内容不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'talk'" label="角色 *" v-model="form.roleName"
      :rules="[v => !!v || '角色不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'talk'" label="持续时间 *" v-model="form.speakTime"
      :rules="[v => !!v || '持续时间不能为空']" type="number" ></v-text-field>


    <v-text-field v-if="form.templateId === 'OpenForm'" label="表单类型 *" v-model="form.formType"
      :rules="[v => !!v || '表单类型不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'OpenForm'" label="表单名称 *" v-model="form.formName"
      :rules="[v => !!v || '表单类型不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'PlayVideo'" label="视频名称 *" v-model="form.videoName"
      :rules="[v => !!v || '视频名称不能为空']"></v-text-field>

    <v-text-field v-if="form.templateId === 'PlayVideo'" label="播放时长(秒) *" v-model="form.videoTime"
      :rules="[v => !!v || '播放时长(秒) 不能为空']"></v-text-field>

    <v-select
      v-if="form.templateId === 'MoveCamera'"
      :items="editorCameraPositionList"
      v-model="form.checkPositionId"
      item-text="name"
      item-value="_id"
      label="所有视角"
    ></v-select>

    <v-row v-if="form.templateId === 'MoveCamera'">
      <v-col col="3">
        <span>位置 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x *" type="number" v-model="form.positionx" :rules="[v => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y *" type="number" v-model="form.positiony" :rules="[v => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" type="number" v-model="form.positionz" :rules="[v => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="form.templateId === 'MoveCamera'">
      <v-col col="3">
        <span>角度 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x" type="number" v-model="form.anglex"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y" type="number" v-model="form.angley"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z" type="number" v-model="form.anglez"></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="form.templateId === 'MoveCamera'">
      <v-col col="3">
        <span>四元素 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x *" type="number" v-model="form.quaternionx" :rules="[v => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y *" type="number" v-model="form.quaterniony" :rules="[v => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" type="number" v-model="form.quaternionz" :rules="[v => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" type="number" v-model="form.quaternionw" :rules="[v => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
    </v-row>

    <v-select item-text="label" item-value="value" v-if="form.templateId === 'MoveCamera'" :items="[
      { value: 'sy', label: '直达' },
      { value: 'py', label: '匀速移动' },
    ]" v-model="form.moveType" label="移动方式 *" :rules="[v => !!v || '移动方式不能为空']"></v-select>

    <v-text-field v-if="form.templateId === 'MoveCamera'" type="number" label="时间 *" v-model="form.pyTime"
      :rules="[v => !!v || '时间 不能为空']"></v-text-field>


    <v-select item-text="label" item-value="value" v-if="form.templateId === 'Effects'" :items="[
      { value: 'show', label: '显示' },
      { value: 'hide', label: '隐藏' },
    ]" v-model="form.effectsMode" label="特效模式 *" :rules="[v => !!v || '特效模式不能为空']"></v-select>

    <v-select item-text="label" item-value="value" v-if="form.templateId === 'Effects'" :items="[
      { value: 'fire', label: '火焰' },
      { value: 'smoke', label: '烟雾' },
    ]" v-model="form.effectsCategory" label="特效种类 *" :rules="[v => !!v || '特效种类不能为空']"></v-select>

    <v-row v-if="form.templateId === 'Effects'">
      <v-col col="3">
        <span>位置 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x *" type="number" v-model="form.effectsPosX" :rules="[v => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y *" type="number" v-model="form.effectsPosY" :rules="[v => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" type="number" v-model="form.effectsPosZ" :rules="[v => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="form.templateId === 'Effects'">
      <v-col col="3">
        <span>角度 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x *" type="number" v-model="form.effectsAngleX" :rules="[v => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y *" type="number" v-model="form.effectsAngleY" :rules="[v => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" type="number" v-model="form.effectsAngleZ" :rules="[v => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
    </v-row>

    <v-row v-if="form.templateId === 'Effects'">
      <v-col col="3">
        <span>比例 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x *" type="number" v-model="form.effectsScaleX" :rules="[v => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y *" type="number" v-model="form.effectsScaleY" :rules="[v => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" type="number" v-model="form.effectsScaleZ" :rules="[v => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
    </v-row>

    <v-textarea
      v-if="form.templateId === 'OpenImage'"
      v-model="form.attachments"
      label="图片资源 *"
      rows="1"
      auto-grow
      readonly
      :rules="[(v) => !!v || '图片资源不能为空']"
      @mouseup.native.stop="focusAttachment('0')"
    ></v-textarea>

    <v-textarea
      v-if="form.templateId === 'PlayVideo'"
      v-model="form.attachments"
      label="视频资源 *"
      rows="1"
      auto-grow
      readonly
      :rules="[(v) => !!v || '视频资源不能为空']"
      @mouseup.native.stop="focusAttachment('1')"
    ></v-textarea>

    <v-textarea
      v-if="form.templateId === 'PlayAudio'"
      v-model="form.attachments"
      label="音频资源 *"
      rows="1"
      auto-grow
      readonly
      :rules="[(v) => !!v || '音频资源不能为空']"
      @mouseup.native.stop="focusAttachment('2')"
    ></v-textarea>


    <ResourceLibrarySelect
      :dialogEdit.sync="showSelectDialog"
      :checkMod="resourceList"
      :defaultType="defaultType"
      :maxNumber="1"
      @handleCancel="showSelectDialog = false"
      @handleSubmit="handleSelectSubmit"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { actionTypeMap } from '@/utils/dict';
import ResourceLibrarySelect from "@/components/Resource/ResourceLibrarySelect";
let dict = actionTypeMap;
export default {
  components: {
    ResourceLibrarySelect,
  },
  computed: {
    ...mapGetters(['editorCameraPositionList'])
  },
  data() {
    return {
      form: {},
      actionMap: {},
      list: [],
      disabled: false,
      // 资源弹窗
      showSelectDialog: false,
      resourceList: [],
      defaultType: "",
    }
  },
  watch: {
    'form.templateId'(val) {
      this.form.templateName = dict[val]
    },
    'form.checkPositionId'(val) {
      const data = this.editorCameraPositionList.find(item => item._id === val);
      const { x: px, y: py, z: pz } = data.freeCamera.position;
      this.form.positionx = ''+px; 
      this.form.positiony = ''+py; 
      this.form.positionz = ''+pz; 

      const { x: qx, y: qy, z: qz, w: qw } = data.freeCamera.quaternion;
      this.form.quaternionx = ''+qx; 
      this.form.quaterniony = ''+qy; 
      this.form.quaternionz = ''+qz;
      this.form.quaternionw = ''+qw;
    }
  },
  methods: {
    init(form) {
      this.form = form
    },
    // 资源弹窗
    focusAttachment(type) {
      this.defaultType = type;
      this.showSelectDialog = true;
      // 解决第一次弹窗闪屏问题
      setTimeout(() => {
        this.showSelectDialog = true;
      }, 100);
      this.resourceList = this.form.attachment_url;
    },
    handleSelectSubmit(checkList) {
      console.log(checkList);
      this.resourceList = checkList;
      this.form.attachment_url = checkList.map((item) => {
        return {
          _id: item._id,
          name: item.name,
        };
      });
      this.form.attachments = checkList.map((item) => item.name).join(",");
      this.showSelectDialog = false;
    },
  }
}
</script>